<template>
  <div class="card-custom go-curve cell small-12 medium-6 text-left">
    <div class="grid-x grid-margin-x">
      <div class="cell small-4 do-centering">
        <img :src="img" alt="">
      </div>
      <div class="cell small-8">
        <div class="grid-x grid-margin-x do-centering">
          <div class="cell">
            <h5><b>{{ title }}</b></h5>
            <p>{{ content }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvantageCard',
  props: ['title', 'img', 'content']
}
</script>

<style lang="scss" scoped>
.card-custom {
  background: #fff;
  padding: 24px 32px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  margin-top: 10px;
  img {
    width: 100%;
    max-width: 100px;
    margin: 0 auto;
  }
  p {
    margin-top: 1em;
    text-indent: 1em;
  }
}
</style>

